module.exports = __webpack_public_path__ + "static/img/protocol-send-client.1de1ca9f.png";